import { EnrolledSessions } from './enrolled-sessions.model';

/**
 * Enrollment model
 * TODO: Need to correlate course model and user model with enrollments
 */
export class Enrollment {
  constructor(
    public id: number, // Same as course ID
    public name: string, // Same as course name
    public url: string, // External url to Docebo course
    public totalTime: number, // Not currently being used
    public duration: number,
    public completePercent: string, // Not currently being used
    public status: string,
    public canEnter: boolean,
    public sessionDateBegin: string, // Not currently being used
    public type: string,
    public locationName: string,
    public enrollEndDate: string, // Not currently being used
    public enrolledSessions: EnrolledSessions[],
    public learningType?: string,
    public enrolledMessage?: string
  ) {}
}
